import request from '@/utils/request'

// 查询资产盘点列表
export function queryAssetInventory(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/queryAssetInventory',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询仓库列表
export function queryShopHouse(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/shopHouse.queryShopHouse',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 保存资产盘点
export function saveAssetInventory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/saveAssetInventory',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0 || response.status === 200) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '保存失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 更新资产盘点
export function updateAssetInventory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/updateAssetInventory',
      method: 'post',
      data,
      headers: {
        'Content-Type': 'application/json'
      }
    }).then(response => {
      const res = response.data
      if (res.code === 0 || response.status === 200) {
        resolve(res)
      } else {
        reject(new Error(res.msg || '更新失败'))
      }
    }).catch(error => {
      reject(error)
    })
  })
}

// 查询资产盘点商品
export function queryAssetInventoryProduct(params) {
  return new Promise((resolve, reject) => {
    request({
      url: '/inventory.queryAssetInventoryProduct',
      method: 'get',
      params
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}

// 删除资产盘点
export function deleteAssetInventory(data) {
  return new Promise((resolve, reject) => {
    request({
      url: '/assetInventory/deleteAssetInventory',
      method: 'post',
      data
    }).then(response => {
      const res = response.data
      resolve(res)
    }).catch(error => {
      reject(error)
    })
  })
}